{
  "buttonGenerate": "Generate QR",
  "inputTextLabel": "QR text",
  "inputTextPlaceholder": "Write the desired text..",
  "buttonReset": "Generate another QR",
  "downloadFormat": "Download {format}",
  "generateSuccess": "Here’s your QR code"
}
